import React from 'react';
import { navigate, Link } from 'gatsby';
import promotion from '../../../../../promotion_config';

const Welcome = ({ className = '', user, actions }) => {
    const logoutClick = async e => {
        await actions.userActions.logout();
        navigate('/logout');
        e.preventDefault();
    };

    const logInLinks = (user, actions) => {
        if (user.loggedIn) {
            return (
                <div>
                    <a
                        id="logout-btn"
                        className="mx-auto sign-out-btn theme-btn"
                        href="#!"
                        onClick={logoutClick}
                    >
                        Logout
                    </a>
                    <a
                        className="mx-auto theme-btn"
                        href={promotion.accountLink}
                        target="_blank"
                        rel="noreferrer"
                    >
                        My Account
                    </a>
                </div>
            );
        } else {
            return (
                <div>
                    <Link
                        id="login-btn"
                        className="mx-auto theme-btn"
                        activeClassName="active"
                        to="/login"
                        onClick={refresh}
                    >
                        Login
                    </Link>
                    <a
                        className="mx-auto theme-btn"
                        href={promotion.registerLink}
                        target="_blank"
                        rel="noreferrer"
                    >
                        Register
                    </a>
                </div>
            );
        }
    };

    const refresh = () => {
        document.getElementById('login-btn').blur();
    };

    const renderName = user => {
        if (user.loggedIn) {
            return <p>Welcome, {user.player.first_name}!</p>;
        } else {
            return;
        }
    };

    return (
        <div className={'welcome ' + className}>
            {renderName(user)}
            {logInLinks(user, actions)}
        </div>
    );
};

export default Welcome;
